import { render, staticRenderFns } from "./Storefront.vue?vue&type=template&id=3aaa852c&"
import script from "./Storefront.vue?vue&type=script&lang=js&"
export * from "./Storefront.vue?vue&type=script&lang=js&"
import style0 from "./Storefront.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports